export const getAiToolApiConfig = () => ({
  withCredentials: true,
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
})

export const getAiToolPdfApiConfig = () => ({
  withCredentials: true,
  credentials: 'include',
  headers: {
    Accept: 'text/html,application/json,*/*',
  },
})
